import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { AdministrationEndpoints } from "@dmms/shared/data-access/administration/types/administration-endpoints";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardCalendarDate,
  IHardFormField,
  IHardFormInputParams,
} from "@hardcode-kz/ui";
import { Validators } from "@angular/forms";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { LangEnum } from "@models/interface-management/localization";
import { IDicBase } from "@models/dictionary/dic-base";
import { IPagination } from "@models/core/pagination";

interface ILocalizationFilterParams extends IPagination {
  period: IHardCalendarDate;
  dateFrom: string;
  dateTo: string;
}

export class LocalizationConfig implements IBaseConfig {
  version = 1;
  dicType = AdministrationEndpoints.Localization;
  showRestore = true;
  isCrudByModal = true;

  fields: IHardFormField[] = [
    {
      name: "code",
      title: "base.code",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.EN, LangEnum.KZ],
        ),
      },
    },
  ];

  tableConfig: ITable<IDicBase[]> = {
    showDefaultActions: true,
    tableColumns: "40px repeat(4,1fr) auto",
    columns: [
      {
        name: "index",
        title: "#",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        name: "code",
        title: "base.code",
        type: HardTableColumnTypeEnum.Html,
      },
      {
        name: "ru",
        title: "base.shortRu",
        parent: "name",
        type: HardTableColumnTypeEnum.Parent,
      },
      {
        name: "kz",
        title: "base.shortKz",
        parent: "name",
        type: HardTableColumnTypeEnum.Parent,
      },
      {
        name: "en",
        title: "base.shortEng",
        parent: "name",
        type: HardTableColumnTypeEnum.Parent,
      },
    ],
  };

  filterTemplateColumns = "1fr";
  filterFields: IFormFieldFilter<IHardFormInputParams>[] = [
    {
      type: HardFormFieldTypeEnum.Input,
      name: "searchTerm",
      placeholder: "base.search",
      outside: true,
      params: {
        isAutoFocus: true,
      },
    },
  ];

  filterCallback(data: ILocalizationFilterParams) {
    return {
      pageIndex: data?.pageIndex || 1,
      pageSize: data?.pageSize || 10,
      searchTerm: data?.searchTerm || "",
    };
  }
}
